import React, { useEffect } from 'react';
import ReconfirmationStagePageContent from '../../components/reconfirmationStage/ReconfirmationStagePageContent';
import getReplacementTokens from '../../utils/GetReplacementTokens';
import { useConsentConfiguration, useConsentInfo } from '../../hooks/queryHooks';
import Loader from '../../components/loader/Loader';
import { useTranslation } from 'react-i18next';

const ReconfirmationPage: React.FC = () => {
  const { consentInfo, isConsentInfoLoading } = useConsentInfo();
  const { consentConfiguration, isConsentConfigurationLoading } = useConsentConfiguration();
  const replacementTokens = getReplacementTokens(consentConfiguration);
  const { t } = useTranslation();

  useEffect(() => {
    if (window.hj) {
      if (consentInfo) {
        window.hj('tagRecording', [`${consentInfo.consentJourneyType}`]);
      }
    }
  }, [consentInfo]);

  if (isConsentConfigurationLoading || isConsentInfoLoading) {
    return <Loader display={true} spinnerText={t('Loading...')} />;
  }

  return (
    <>
      <ReconfirmationStagePageContent consentInfo={consentInfo!} replacementTokens={replacementTokens} />
    </>
  );
};

export { ReconfirmationPage };
export default ReconfirmationPage;
